var _line, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepSeparationROd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 7,
    viewBox: "0 0 180 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.87695,
    y1: 3.41883,
    x2: 176.271,
    y2: 3.41883,
    stroke: "#C0C4E4",
    strokeWidth: 1.33422
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.10895,
    cy: 3.32379,
    r: 3.03473,
    fill: "#C0C4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.558,
    cy: 3.32379,
    r: 3.03473,
    fill: "#C0C4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSeparationROd);
export default __webpack_public_path__ + "static/media/StepSeparationROd.f53e9fa93713939eeb47640bf22d330d.svg";
export { ForwardRef as ReactComponent };